const githubGraphQlEndpoint = 'https://api.github.com/graphql';

const githubGraphQlQuery =
    `query ($cursor: String) {
      organization(login: "SoftwareEngineeringProjectUU") {
        name
        avatarUrl
        url
        membersWithRole(first: 6) {
          nodes {
            login
            avatarUrl
            url
          }
        }
        projectV2(number: 1) {
          ... on ProjectV2 {
            items(first: 100, after: $cursor) {
              pageInfo {
                endCursor
                hasNextPage
              }
              nodes {
                fieldValues(first: 10) {
                  nodes {
                    ... on ProjectV2ItemFieldSingleSelectValue {
                      name
                    }
                  }              
                }
                content{              
                  ...on Issue {
                    __typename
                    number
                    title
                    body
                    createdAt
                    closedAt
                    url
                    milestone {
                      number
                    }
                    assignees(first: 5) {
                      nodes {
                        login
                      }
                    }
                    labels(first: 15) {
                      nodes {
                        name
                      }
                    }
                    comments(first: 15) {
                      nodes {
                        author {
                          login
                        }
                        body
                      }
                    }
                  }
                  ...on PullRequest {
                    __typename
                    number
                    title
                    body
                    createdAt
                    closedAt
                    url
                    assignees(first: 5) {
                      nodes {
                        login
                      }
                    }
                    reviews(first: 10) {
                      nodes {
                        author {
                          login
                        }
                      }
                    }
                    comments(first: 30) {
                      nodes {
                        author {
                          login
                        }
                        body
                      }
                    }
                    closingIssuesReferences(first: 5) {
                      edges {
                        node {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }`;

/**
 * GitHub GraphQL API request query configuration options for fetching group org project management data for visualizing
 * @param {String} cursor GitHub GraphQL API pagination cursor for maintaining track of next page results.
 * @returns {RequestInit} object containing HTTP request method, headers and body with GraphQL query string and cursor.
 */
const githubGraphQlQueryOptions = (cursor) => {
    return {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'Authorization': `Bearer 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`
        },
        body: JSON.stringify({
            query: githubGraphQlQuery,
            variables: { cursor: cursor }
        })
    };
}

export { githubGraphQlEndpoint, githubGraphQlQueryOptions };
